import { lazy, Suspense, useRef } from "preact/compat";

import { useCopySanitizer } from "../../lib/useCopySanitizer";

const Renderer = lazy(() => import("./RemarkRenderer"));

export interface MarkdownProps {
    content: string;
    disallowBigEmoji?: boolean;
}

export default function Markdown(props: MarkdownProps) {
    const ref = useRef<HTMLDivElement>(null);

    // Sanitize text copied via Ctrl+C
    useCopySanitizer({ containerRef: ref });

    if (!props.content) return null;

    return (
        <div ref={ref}>
            {/* @ts-expect-error Typings mis-match. */}
            <Suspense fallback={props.content}>
                <Renderer {...props} />
            </Suspense>
        </div>
    );
}
